export const workflowDrawerWrapperId = "workflowDrawerWrapperId";
export const workflowDrawerHeaderId = "workflowDrawerHeaderId";
